<template>
  <div class="tutorials">
    <div>
      <div
        class="text gpt-ql-editor"
        v-html="content.subTitle || 'Not Set.'"
      ></div>

      <div
        tabindex="0"
        :aria-label="t.title"
        class="tutorial"
        :class="{ disabled: isFinished }"
        v-for="(t, index) in content.tutorials"
        :key="index"
        @click="selectTutorial(t)"
        @keyup.enter="selectTutorial(t)"
      >
        <div class="tutorial-icon">
          <img
            :src="require(`@/assets/images/bot_icons/${t.icon}.jpg`)"
            alt=""
          />
        </div>
        <div class="content">
          <div class="tutorial-title">{{ t.title }}</div>
          <div class="tutorial-content">{{ t.content }}</div>
        </div>
      </div>
    </div>

    <div class="time">{{ message.createAt | localTime }}</div>
  </div>
</template>

<script>
export default {
  name: "gpt-message-tutorial",
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      content: {
        subTitle: "",
        tutorials: [],
      },
    };
  },
  mounted() {
    const content = JSON.parse(this.message.content);
    this.content = content;
  },
  methods: {
    async selectTutorial(t) {
      if (this.isFinished) {
        return;
      }
      // console.log("selectTutorial", t);
      // 意圖用user input 這個欄位 內文不用送，顯示在user端就可以
      // 1. createMessage
      let data = { type: "Text", content: t.content, chatUserRole: "customer" }; // (System, Text, Image, CustomerStatus)
      await this.$store.dispatch("gpt/createMessage", data);
      // 2. chatRender
      this.$store.commit("gpt/cleanBotRenderChatType"); // 清除其餘botRender條件
      this.$store.commit("gpt/saveUserInput", t.botKeyName);
      this.$store.dispatch("gpt/createChatRenderMessage");
    },
  },
  computed: {
    isFinished() {
      return this.$store.state.gpt.botRoom.isFinished;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "gpt.scss";
</style>
